import React from 'react';
import Step1 from '../assets/1.png';
import Step2 from '../assets/2.png';
import Step3 from '../assets/3.png';
import Step4 from '../assets/4.png';

const steps = [
  {
    img: Step1, // make sure these images are in public/images/
    title: 'Step 1',
    subtitle: 'Submit Your Requirement',
    description: 'Provide the details of the goods and the probable time of shifting those goods to Packer and Mover.',
  },
  {
    img: Step2,
    title: 'Step 2',
    subtitle: 'Get A Free Quote',
    description: 'Get 4 free shifting quotations from the best Packers and Movers near your area.',
  },
  {
    img: Step3,
    title: 'Step 3',
    subtitle: 'Compare and Hire',
    description: 'Compare shifting quotes, and hire the best movers that suits your budget.',
  },
  {
    img: Step4,
    title: 'Step 4',
    subtitle: 'We Got You Moved',
    description: 'Confirm your date and time of booking and schedule your move.',
  },
];

const Steps = () => {
  return (
    <section className="bg-light py-16 px-6 text-center">
      <h2 className="text-4xl font-bold text-primary mb-2">Relocate In 4 Easy Steps</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col items-center text-dark">
            <img src={step.img} alt={step.subtitle} className="h-60 w-60 mb-2" />
            {/* <h3 className="text-lg font-semibold text-primary">{step.title}</h3> */}
            <p className="font-bold mt-1 text-left text-lg text-primary ">{step.subtitle}</p>
            <p className="text-sm mt-2 ">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Steps;
